"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideOver = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./style.scss");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = require("@headlessui/react");
var SlideOver = function (_a) {
    var open = _a.open, setOpen = _a.setOpen, children = _a.children, _b = _a.time, time = _b === void 0 ? 300 : _b, panelClassName = _a.panelClassName;
    var _c = (0, react_1.useState)(false), transition = _c[0], setTransition = _c[1];
    var _d = (0, react_1.useState)(false), isClosed = _d[0], setIsClosed = _d[1];
    var cn = classnames_1.default;
    var onClose = function () {
        setIsClosed(true);
    };
    (0, react_1.useEffect)(function () {
        var timeout;
        if (isClosed) {
            setTransition(false);
            timeout = setTimeout(function () {
                setOpen(false);
            }, time);
        }
        return function () {
            clearTimeout(timeout);
        };
    }, [isClosed]);
    (0, react_1.useEffect)(function () {
        var timeout = setTimeout(function () {
            setTransition(true);
        }, time);
        return function () {
            clearTimeout(timeout);
            setTransition(false);
            setIsClosed(false);
        };
    }, [open]);
    return ((0, jsx_runtime_1.jsx)(react_2.Transition.Root, __assign({ show: open, as: react_1.Fragment }, { children: (0, jsx_runtime_1.jsxs)(react_2.Dialog, __assign({ as: "div", className: "slide-over-dialog", onClose: onClose }, { children: [(0, jsx_runtime_1.jsx)("div", { className: cn("slide-over-shadow", { open: transition }) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "slide-over-child" }, { children: (0, jsx_runtime_1.jsx)(react_2.Dialog.Panel, { children: children(onClose, cn(panelClassName, { open: transition })) }) }))] })) })));
};
exports.SlideOver = SlideOver;
